import styled, { css } from 'styled-components'
import PulseLoader from 'react-spinners/PulseLoader'

import Icon from '../Icon'
import LinkC from '../Link'

import type { ActionButtonProps } from './index'

export const Link = styled(LinkC)`
  display: inline-flex;
  align-items: center;
  text-decoration: none;

  > * {
    width: 100%;
  }
`

export const Button = styled.button<{
  disabled?: boolean
  $variant: ActionButtonProps['variant']
  $isLoading?: boolean
}>`
  display: inline-flex;
  align-items: center;
  padding: 12px 30px;
  border-radius: 4px;
  min-width: 120px;
  justify-content: center;
  transition: all 0.2s ease-out;
  cursor: pointer;

  ${(props) => props.theme.fonts.BBRegular}
  font-size: 12px;
  text-transform: uppercase;

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      pointer-events: none;
    `}

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `}
  ${(props) => {
    switch (props.$variant) {
      case 'primary':
        return css`
          border: 1px solid ${(props) => props.theme.colors.pureBlack};
          color: ${(props) => props.theme.colors.pureWhite};
          background-color: ${(props) => props.theme.colors.pureBlack};
        `
      case 'secondary':
        return css`
          border: 1px solid ${(props) => props.theme.colors.pureBlack};
          color: ${(props) => props.theme.colors.pureBlack};
          background-color: ${(props) => props.theme.colors.pureWhite};
        `
      case 'link':
        return css`
          background-color: transparent;
          height: auto;
          color: ${(props) => props.theme.colors.pureBlack};
          border: none;
          padding: 0;
        `
    }
  }}
  &:hover {
    ${(props) => {
      if (!props.disabled) {
        switch (props.$variant) {
          case 'primary':
            return css`
              color: ${(props) => props.theme.colors.pureBlack};
              background-color: ${(props) => props.theme.colors.pureWhite};
            `
          case 'secondary':
            return css`
              color: ${(props) => props.theme.colors.pureWhite};
              background-color: ${(props) => props.theme.colors.pureBlack};
            `
        }
      }
    }}
  }
`

export const IconIn = styled(Icon)<{ iconSide?: string; width?: number; height?: number }>`
  position: relative;
  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `};
  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
    `};
  margin-left: ${(props) => (props.iconSide === 'right' ? '10px' : '0')};
  margin-right: ${(props) => (props.iconSide === 'left' ? '10px' : '0')};
`

export const Spinner = styled(PulseLoader)``
